// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"47":"4fd28bec5f5633439f0b","174":"78ad08ebb014c131eb27","284":"25af8a63fb5894247722","832":"5b5bc24d66d480a93942","859":"2ac535d0b9cb2f5a487f"}[chunkId] + ".js";
};